import React, { useState } from "react";
import {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnUnderline,
  BtnUndo,
  Editor,
  EditorProvider,
  Toolbar,
} from "react-simple-wysiwyg";

function RichEditor({ value, handleChangeValue }) {
  return (
    <EditorProvider>
      <Editor
        value={value}
        onChange={(e) => {
          handleChangeValue(e?.target?.value);
        }}
      >
        <Toolbar>
          <BtnItalic />
          <BtnUnderline />
          <BtnStrikeThrough />
          <BtnLink />
          <BtnClearFormatting />
          <BtnNumberedList />
          <BtnBold />
          <BtnBulletList />
          <BtnUndo />
          <BtnRedo />
        </Toolbar>
      </Editor>
    </EditorProvider>
  );
}

export default RichEditor;
